/**
 * LicenseSpotCount Component
 */

import './styles.scss';

import * as classNames from 'classnames';
import * as React from 'react';
import * as BEM from 'react-bem-helper';

import ConnectedLicenseBuilderContainer, {
  LicenseComponentProps,
} from '../../../../../containers/ConnectedLicenseBuilderComponent';

import Button from '../../../../atoms/buttons/Button';
import Heading from '../../../../atoms/text/Heading';
import { Span } from '../../../../atoms/text/Label';

type LicenseComponentEdge = GQL.ISpotCountEdge;
type LicenseComponentNode = GQL.ISpotCount;
type LicenseComponentOwnProps = LicenseComponentProps<LicenseComponentEdge>;

const classes = new BEM('license-builder__step');

class LicenseSpotCount extends React.Component<LicenseComponentOwnProps, {}> {

  shouldComponentUpdate(nextProps: LicenseComponentOwnProps) {
    const should = nextProps.selectedParam !== this.props.selectedParam ||
      nextProps.editingUsageIndex !== this.props.editingUsageIndex;

    return should;
  }

  renderSpotCountButton({ internal_id, name }: LicenseComponentNode) {
    const id = internal_id! as LicenseSpotCountTypeIdentifier;
    const component: ILicenseComponent = { id, name };
    const selectedParam = this.props.selectedParam as ILicenseComponent | null | undefined;
    const extraClassName = classNames(
      { 'is-active': !!selectedParam && id === selectedParam.id },
    );
    return (
      <Button
        onClick={() => {
          this.props.setParam(component);
        }}
        {...classes('button', '', extraClassName) }
        label={name}
        size="small"
        colorScheme="white"
      />
    );
  }

  render() {
    const {
      editingUsageIndex,
      medium,
    } = this.props;

    return (
      <div {...classes('', 'spot-count') }>
        <Heading
          is="h4"
          {...classes('title') }
        >Number of {medium === 2006 || medium === 2011 ? 'Spots' : 'Films'}:
        </Heading>
        <Span size="medium" variant="note" {...classes('note') }>Unlimited cut-downs are included.</Span>
        <ul>
          {this.props.data.map(({ node }) => (
            <li key={`${editingUsageIndex}-${node!.internal_id!}`}>
              {this.renderSpotCountButton(node!)}
            </li>
          ))}
        </ul>
      </div>
    );
  }
}

const ConnectedLicenseSpotCount =
  ConnectedLicenseBuilderContainer<LicenseComponentEdge>(LicenseSpotCount, 'spot_count');

export default ConnectedLicenseSpotCount;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/components/molecules/forms/license-builder/SelectSpotCount/index.tsx